export default defineNuxtPlugin(nuxtApp => {
   // Only run on client side
   if (import.meta.server) return;

   const config = useRuntimeConfig();
   const gtmId = config.public.gtmId; // Should be GTM-XXXXXXX

   // Initialize dataLayer for GTM
   window.dataLayer = window.dataLayer || [];

   // Define gtag function
   window.gtag =
      window.gtag ||
      function () {
         window.dataLayer.push(arguments);
      };

   // Set default consent
   window.gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted',
      wait_for_update: 1000,
   });

   // Push GTM initialization to dataLayer
   window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
   });

   // Load GTM script (not gtag script)
   useHead({
      script: [
         {
            src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
            async: true,
            defer: true,
            'data-category': 'analytics',
            'data-service': 'gtm',
         },
      ],
      noscript: [
         {
            innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
            tagPosition: 'bodyClose', // Ensures noscript is injected into the footer
         },
      ],
   });

   // console.log(`🏷️ GTM initialized with ID: ${gtmId}`);

   // Define trackPageView function directly in plugin
   const trackPageView = () => {
      if (typeof window !== 'undefined' && window.gtag && gtmId) {
         const route = useRoute();

         // Send page_view event (GA4 standard)
         window.gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: route.fullPath,
         });

         // Also update config for enhanced measurement
         window.gtag('config', gtmId, {
            page_path: route.fullPath,
            page_title: document.title,
         });

         // console.log(`📄 Page View: ${document.title} (${route.fullPath})`);
      }
   };

   nuxtApp.hook('app:mounted', () => {
      // Wait a bit longer for GTM to fully load
      setTimeout(() => {
         trackPageView();
         // console.log("📄 Initial page view tracked");
      }, 500);
   });

   nuxtApp.hook('page:finish', () => {
      // Small delay to ensure the page has fully loaded
      nextTick(() => {
         setTimeout(() => {
            trackPageView();
            // console.log("📄 Page view tracked on route change");
         }, 100);
      });
   });
});
